import Common from "./common.js";
import "../../scss/v5/main.scss";
import ExpandableMovie from "./components/ExpandableMovie.js";
import LoadingMovies from "./components/LoadingMovies.js";
import YouTubeHoverPreview from "./components/YouTubeHoverPreview.js";
import SectionNavigator from "./components/SectionNavigator.js";

Common.initPage(async () => {
  const headerHeight = document.querySelector("header#header")?.offsetHeight || 0;

  document.querySelectorAll(".item-list.movie-list > li > a").forEach((item) => {
    ExpandableMovie(item, { scrollOffset: headerHeight }).render();
  });

  LoadingMovies({
    loadingSections: Array.from(document.querySelectorAll(".item-list-section.loading")),
  }).render();

  // Initialize YouTube hover previews
  document.querySelectorAll(".trailer-list li[data-youtube-id]").forEach((item) => {
    YouTubeHoverPreview(item).mount();
  });

  // Initialize section navigator
  const sectionNavLinks = Array.from(document.querySelectorAll(".main-sections-nav > li > a"));
  if (sectionNavLinks.length > 0) {
    SectionNavigator({
      sectionLinks: sectionNavLinks,
    }).mount();
  }
});
